/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-14 15:40:01
 */

import http from "@/api";

/**
 * @name 登录模块
 */
// * facebook 授权
export const FacebookAUthorization = params => {
	const { appId, uid } = params;
	const origin = location.origin;

	window.open(
		`https://business-api.facebook.com/portal/auth?app_id=${appId}&state={ "uid": ${uid}, "app_id": ${appId}, "redirect_uri":
			"${location.origin}/account/index"}&redirect_uri=${location.origin}/api/facebook/business/auth/callback`
	);
};

/** 查看授权集合 */
export const fetchFacebookAuthList = params => {
	return http.get("/facebook/business/auth/list", params);
};

export const fetchRemoveFacebookAuth = params => {
	return http.get("/facebook/business/auth/remove", params);
};

/** 获取授权的AppId */
export const fetchFacebookSetting = () => {
	return http.get("/facebook/business/auth/setting");
};

/** 获取广告账号列表 */
export const fetchADAccountList = params => {
	return http.get("/facebook/adv/list", params);
};

/** 广告账号链接 */
export const fetchCennectAdvAccount = params => {
	return http.post("/facebook/adv/active", params);
};

/** 断开广告账号链接 */
export const fetchUnCennectAdvAccount = params => {
	return http.post("/facebook/adv/unActive", params);
};

export const fetchAsyncAdvAccount = params => {
	return http.get("/facebook/adv/sync", params);
};

/** 但个广告账户下绑定的规则 */

export const fetchAdvBindingList = params => {
	return http.get("/adv/strategy/adv/binding/list", params);
};

/** 切换单个广告账号绑定状态 */
export const fetchToggleAdvBinding = params => {
	return http.post("/adv/strategy/adv/binding/toggle", params);
};
